module.exports = __webpack_public_path__ + "static/media/email-svgrepo-com.12935541.svg";